export default {
  getContainerActive: (state) => state.containerActive,
  getNewCount: (state) => state.newCount,
  getNotifications: (state) => state.notifications.results,
  getNotification: (state) => state.notification,
  getLastKey: (state) => state.notifications.lastKey,
  getNotiTarget: (state) => state.notiTarget,
};
